import React, { useState, useRef, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment-timezone";
import TableRow from "@mui/material/TableRow";
import { Modal, Form, Button } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";

const P2PBetsCompetition = ({ p2pbetArr }) => {

    const [selectedBet, setSelectedBet] = useState({});
    const [show, setShow] = useState(false);
    const handleBetClose = () => setShow(false);

    console.log("p2p betArr", p2pbetArr);

    return (
        <>
            <div className="col-md-12">
                <div className="custom-table-data mt-4">
                    <h4 className="dark-gray f-bold mb-4">
                       P2P Bet Entries{" "}
                    </h4>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell align="center">Bet ID</TableCell>
                                    {/* <TableCell align="center">Bet Type </TableCell> */}
                                    <TableCell align="center">Sports </TableCell>
                                    <TableCell align="center">Event </TableCell>
                                    <TableCell align="center">Payout(percent) </TableCell>
                                    <TableCell align="center">Rank</TableCell>
                                    <TableCell align="center">Result </TableCell>
                                    <TableCell align="center">bet status </TableCell>
                                    <TableCell align="center">Pool Status </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { p2pbetArr?.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{
                                            "&:last-child td, &:last-child th": {
                                                border: 0,
                                            },
                                        }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {moment(row?.createdDate).format("MM/DD/YYYY")}
                                        </TableCell>
                                        <TableCell align="center">
                                            {/* {row.betId} */}
                                            {row?._id}
                                        </TableCell>
                                        {/* <TableCell align="center">{row.type}</TableCell> */}
                                        <TableCell align="center">
                                            {row?.sport?.name}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.eventName}
                                        </TableCell>
                                        {/* <TableCell align="center">
                                  {row.playerData[0]?.statName}
                                </TableCell> */}

                                        <TableCell align="center">
                                           {row?.status === "Active" ? "Pending" : `$${row?.winAmount?.toFixed(2)}`}({row?.winPayout})
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.rank}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.status}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.defineresult}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.poolSizeFilled}{"/"}{row?.poolSize}
                                            {/* <Button
                                                variant="primary"
                                                className="mrglft10"
                                                onClick={() => {
                                                    setShow(true);
                                                    setSelectedBet(row);

                                                }}
                                            >
                                                View
                                            </Button> */}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            {show && (
                <Modal
                    show={show}
                    onHide={handleBetClose}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Bett Details
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col-md-12" style={{ display: 'flex', gap: '20px' }}>
                            <div className="col-md-6">
                                <ListGroup as="ul">
                                    <ListGroup.Item as="li" active>
                                        Bet Detail
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Bet Id : </span>
                                        <span> {selectedBet.id} </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        disabled
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>User : </span>
                                        <span> {selectedBet.userId} </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        disabled
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Type : </span>
                                        <span> {selectedBet.type} </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        disabled
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Amount : </span>
                                        <span>
                                            {"$"}
                                            {selectedBet.amount != undefined
                                                ? selectedBet.amount.toFixed(2)
                                                : 0.0}{" "}
                                        </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Potential : </span>
                                        <span>
                                            {"$"}
                                            {selectedBet.projectedAmount != undefined
                                                ? selectedBet.projectedAmount.toFixed(2)
                                                : 0.0}{" "}
                                        </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Stake : </span>
                                        <span>
                                            {"$"}
                                            {selectedBet.wager != undefined
                                                ? selectedBet.wager.toFixed(2)
                                                : 0.0}{" "}
                                        </span>
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>

                            <div className="col-md-5">
                                <ListGroup as="ul">
                                    <ListGroup.Item as="li" active>
                                        Actions
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Status : </span>
                                        <span> {selectedBet.status} </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Result : </span>
                                        <span> {selectedBet.defineresult} </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        disabled
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Cashout : </span>
                                        <span> {selectedBet.status != 'SETTLED' ? 'No' : 'Yes'} </span>
                                    </ListGroup.Item>
                                    <ListGroup.Item
                                        as="li"
                                        disabled
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <span>Created Time : </span>
                                        <span>



                                            {moment(selectedBet.createdDate).format("MM/DD/YYYY")} </span>
                                    </ListGroup.Item>



                                </ListGroup>

                            </div>
                        </div>

                        <div className="col-md-12" style={{ marginTop: '30px' }}>
                            <TableContainer component={Paper}>
                                <Table
                                    size="small"
                                    aria-label="a dense table"
                                    stickyHeader
                                    aria-label="sticky table"
                                    sx={{ minWidth: 500 }}
                                    aria-label="custom pagination table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                Market ID
                                            </TableCell>
                                            <TableCell align="center">
                                                Stat Name
                                            </TableCell>
                                            <TableCell align="center">Match </TableCell>
                                            <TableCell align="center">
                                                Player Name
                                            </TableCell>
                                            <TableCell align="center">
                                                Player Team
                                            </TableCell>
                                            <TableCell align="center">More</TableCell>
                                            <TableCell align="center">Less</TableCell>
                                            <TableCell align="center">Points</TableCell>
                                            <TableCell align="center">
                                                Final Score
                                            </TableCell>
                                            <TableCell align="center">Result </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedBet.playerData.map((odd) => (
                                            <TableRow
                                                key={odd.idUser}
                                                sx={{
                                                    "&:last-child td, &:last-child th": {
                                                        border: 0,
                                                    },
                                                }}
                                            >
                                                <TableCell align="center">
                                                    {odd.marketId}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.statName}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd?.playerevent?.teamH?.abv} {"-"}{" "}
                                                    {odd?.playerevent?.teamA?.abv}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.teamName}
                                                </TableCell>
                                                <TableCell align="center">

                                                    {`${odd.isMore}`}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {" "}
                                                    {`${odd.isLess}`}
                                                </TableCell>
                                                <TableCell>{odd.points}</TableCell>
                                                <TableCell align="center">
                                                    {odd.finalpoints}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.defineresult}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleBetClose}>
                            Close
                        </Button>
                        {/* <Button variant="primary" onClick={handleClose}>
                  Save Changes
                </Button> */}
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default P2PBetsCompetition